import { notification } from 'antd';
import React, { useEffect } from 'react';
import { MessageResponse } from 'shared/types/types';

export type ResponseResult = {
  isUpdateSuccess?: boolean;
  isUpdateError?: boolean;
  updateResult?: MessageResponse;
  updateError?: any;
};

const useResponse = (response: ResponseResult) => {
  const { updateError, updateResult, isUpdateError, isUpdateSuccess } = response;
  useEffect(() => {
    if (isUpdateError) {
      notification.error({ message: (updateError as any).data.message });
    }
  }, [isUpdateError]);

  useEffect(() => {
    if (isUpdateSuccess) {
      notification.success({ message: updateResult?.message });
    }
  }, [isUpdateSuccess]);
};

export default useResponse;
